export const conditionalOperator = x => (x ? y => pure(y) : pure(identity));

export const logicalAndOperator = x => (x ? identity : pure(x)); //logical short-circuiting

export const logicalOrOperator = x => (x ? pure(x) : identity); //logical short-circuiting

export const logicalNotOperator = x => !x;

export const plusOperator = x => y => x + y;

export const equalsOperator = x => y => x === y;

export const minOperator = x => y => min(x, y);

export const maxOperator = x => y => max(x, y);

function pure(x) {
  return () => x;
}

function identity(x) {
  return x;
}

function min(x, y) {
  return x <= y ? x : y;
}

function max(x, y) {
  return x >= y ? x : y;
}
